import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatCheckboxChange } from '@angular/material';
import { ListItem } from './fc-list-item.types';

@Component({
  selector: 'fc-list-item',
  templateUrl: './fc-list-item.component.html',
  styleUrls: ['./fc-list-item.component.scss']
})
export class FcListItemComponent {

  @Input()
  public item: ListItem<any>;

  @Input()
  public disabled = false;

  @Output()
  public readonly selectedChange = new EventEmitter<ListItem<any>>();

  onCheckboxChange(event: MatCheckboxChange): void {
    this.item.selected = event.checked;
    this.selectedChange.emit(this.item);
  }

}
